import type { ReactNode } from "react";
import { styled } from "@pigment-css/react";
import { Pill } from "@acto/taskpane/field-sales-2/components/primitives/Pill";
import { glassCapsulePress } from "@acto/taskpane/field-sales-2/styles/glassCapsulePress";

const Root = styled(Pill)(({ theme }) => ({
  gap: theme.fieldSalesTwo.spacing[8],
  color: theme.fieldSalesTwo.colors.neutral[900],
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[168],
  cursor: "pointer",
  whiteSpace: "nowrap",
  appearance: "none",
  WebkitAppearance: "none",
  ...glassCapsulePress(theme, { restShadow: theme.fieldSalesTwo.shadows.glass }),
  '&[data-disabled="true"]': {
    opacity: 0.5,
    pointerEvents: "none",
  },
}));

interface BottomNavActionPillProps {
  onClick?: () => void;
  children: ReactNode;
  disabled?: boolean;
}

export function BottomNavActionPill({ onClick, children, disabled }: BottomNavActionPillProps) {
  return (
    <Root as="button" type="button" onClick={onClick} disabled={disabled} data-disabled={disabled}>
      {children}
    </Root>
  );
}
